// Bonus SKU selection actions
export const SET_SELECTED_BONUS_SKUS = 'SET_SELECTED_BONUS_SKUS'
export const CLEAR_SELECTED_BONUS_SKUS = 'CLEAR_SELECTED_BONUS_SKUS'
export const SET_AVAILABLE_BONUS_SKUS = 'SET_AVAILABLE_BONUS_SKUS'
export const SET_AS_OF_DATE = 'SET_AS_OF_DATE'

export const setSelectedBonusSkus = (selectedSkus) => ({
  type: SET_SELECTED_BONUS_SKUS,
  payload: selectedSkus,
})

export const clearSelectedBonusSkus = () => ({
  type: CLEAR_SELECTED_BONUS_SKUS,
})

export const setAvailableBonusSkus = (availableSkus) => ({
  type: SET_AVAILABLE_BONUS_SKUS,
  payload: availableSkus,
})

export const setAsOfDate = (asOfDate) => ({
  type: SET_AS_OF_DATE,
  payload: asOfDate,
})
